import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

import ChartStockFinacial from '../../chart/chartStockFinacial';

import * as _ from 'lodash';
import { getQ } from 'utils';
import { log } from 'utils';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function DongTien(props) {
  const { freqActive, setFreqActive, fsRatio, t, theme } = props;

  const [tongTaisan, setTongTaiSan] = React.useState([]);
  const [noNganHan, setNoNganHan] = React.useState([]);
  const [noDaiHan, setNoDaiHan] = React.useState([]);
  const [vonChuSH, setVonChuSH] = React.useState([]);

  const preFSRatio = usePrevious(fsRatio);

  React.useEffect(() => {
    if (fsRatio && !_.isEqual(fsRatio, preFSRatio)) {
      processData();
    }
  }, [fsRatio]);

  function processData() {
    const _hoatDongKinhDoanh = _.map(fsRatio, 'CF_OPERATING');
    const _hoatDongTaiChinh = _.map(fsRatio, 'CF_FINANCING');
    const _hoatDongDauTu = _.map(fsRatio, 'CF_INVESTING');
    const _tuDo = _.map(fsRatio, 'FCF');

    const _time = _.map(fsRatio, 'REPORT_DATE');

    let __hoatDongKinhDoanh = [],
      __hoatDongTaiChinh = [],
      __hoatDongDauTu = [],
      __tuDo = [];

    // log(_time);

    for (let index = 0; index < _time.length; index++) {
      if (freqActive === 'Q') {
        __hoatDongKinhDoanh.push({
          name: getQ(_time[index]),
          value: _hoatDongKinhDoanh[index],
        });
        __hoatDongTaiChinh.push({
          name: getQ(_time[index]),
          value: _hoatDongTaiChinh[index],
        });
        __hoatDongDauTu.push({
          name: getQ(_time[index]),
          value: _hoatDongDauTu[index],
        });
        __tuDo.push({
          name: getQ(_time[index]),
          value: _tuDo[index],
        });
      } else {
        let st = new Date(_time[index].replace(/-/g, "/"));
        __hoatDongKinhDoanh.push({
          name: st.getFullYear() + '',
          value: _hoatDongKinhDoanh[index],
        });
        __hoatDongTaiChinh.push({
          name: st.getFullYear() + '',
          value: _hoatDongTaiChinh[index],
        });
        __hoatDongDauTu.push({
          name: st.getFullYear() + '',
          value: _hoatDongDauTu[index],
        });
        __tuDo.push({
          name: st.getFullYear() + '',
          value: _tuDo[index],
        });
      }
    }
    setTongTaiSan(__hoatDongKinhDoanh);
    setNoNganHan(__hoatDongTaiChinh);
    setNoDaiHan(__hoatDongDauTu);
    setVonChuSH(__tuDo);
  }

  // log(fsRatio);

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview"
      style={{ background: 'var(--bg_card_chart)', borderRadius: '2px' }}
    >
      <div className="d-flex pb-2" style={{ flexDirection: 'row-reverse' }}>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Y' ? 'active' : '')
          }
          onClick={() => setFreqActive('Y')}
        >
          {t('algo.ptcp.txt-Year')}
        </Button>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Q' ? 'active' : '')
          }
          onClick={() => setFreqActive('Q')}
        >
          {t('algo.ptcp.txt-Quarter')}
        </Button>
      </div>
      <div
        className="d-grid h-100"
        style={{
          gridTemplateColumns: 'repeat(2, minmax(0px, 1fr))',
          gap: '15px',
        }}
      >
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Operating-cash-flow')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={tongTaisan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Financing-cash-flow')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={noNganHan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Investing-cash-flow')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={noDaiHan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Free-cash-flow')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={vonChuSH}
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(DongTien);
